<template>
  <div>
    <!-- 预加载区域 -->
    <div id="loading">
      <div id="loading-center">
        <div id="loading-center-absolute">
          <div class="loading-icon text-center d-flex flex-column align-items-center justify-content-center">
            <img class="loading-logo" src="/assets/images/preloader.svg" alt="icon">
          </div>
        </div>
      </div>
    </div>
    <!-- 头部区域 -->
    <AppHeader />
    <!-- 页面内容区域 -->
    <slot />
    <!-- 页脚区域 -->
    <AppFooter />
    <!-- 返回顶部区域 -->
    <div class="scroll-up">
      <svg class="scroll-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>
  </div>
</template>

<script setup>
// 导入组件
import AppHeader from '~/components/AppHeader.vue';
import AppFooter from '~/components/AppFooter.vue';

// 引入所有原始 HTML 项目中的 CSS 和 JS
useHead({
  link: [
    { rel: 'shortcut icon', href: '/assets/images/favicon.png' },
    { rel: 'stylesheet', href: '/assets/css/bootstrap.min.css' },
    { rel: 'stylesheet', href: '/assets/css/all.min.css' },
    { rel: 'stylesheet', href: '/assets/css/swiper-bundle.min.css' },
    { rel: 'stylesheet', href: '/assets/css/magnific-popup.css' },
    { rel: 'stylesheet', href: '/assets/css/animate.css' },
    { rel: 'stylesheet', href: '/assets/css/nice-select.css' },
    { rel: 'stylesheet', href: '/assets/css/style.css' }
  ],
  script: [
    { src: '/assets/js/jquery-3.7.1.min.js', body: true },
    { src: '/assets/js/bootstrap.min.js', body: true },
    { src: '/assets/js/swiper-bundle.min.js', body: true },
    { src: '/assets/js/jquery.counterup.min.js', body: true },
    { src: '/assets/js/wow.min.js', body: true },
    { src: '/assets/js/magnific-popup.min.js', body: true },
    { src: '/assets/js/nice-select.min.js', body: true },
    { src: '/assets/js/isotope.pkgd.min.js', body: true },
    { src: '/assets/js/jquery.waypoints.js', body: true },
    { src: '/assets/js/script.js', body: true }
  ]
})
</script>
